import * as Role from 'constants/role';
import { isUsuarioUsoMuto } from 'utils';
import { isRoleAuditoriaNsir } from '../../../../helpers/auditoriaNsirPermission';
import { canViewVeiculoReport } from '../../../../helpers/veiculoReportPermission';

const KEY = 'gestaoVeicular';

const canSeeGestaoVeicularItems = ({ authData, userRole, variant }) => {
  const notUsoMuto = !isUsuarioUsoMuto(authData.email);
  if (variant === 'v1') {
    return notUsoMuto && !isRoleAuditoriaNsir(userRole);
  }
  return notUsoMuto;
};

/**
 * Subitens de Gestão Veicular para o menu lateral (V1: href; V2: path).
 */
export const renderGestaoVeicular = ({
  authData,
  userRole,
  moduleConfigurations,
  variant = 'v1',
}) => {
  const canSee = canSeeGestaoVeicularItems({ authData, userRole, variant });
  const canViewRelatorio = canViewVeiculoReport({
    authData,
    userRole,
    moduleConfigurations,
  });
  const routeKey = variant === 'v2' ? 'path' : 'href';

  const mkItem = (title, route, show) => ({
    title,
    [routeKey]: route,
    show,
    key: KEY,
  });

  const isAdmin = userRole === Role.SUPER_ADMIN || userRole === Role.ADMIN;

  return [
    mkItem('Odômetros', '/v2/odometros', canSee),
    mkItem('Veículos', '/v2/veiculos', isAdmin && canSee),
    mkItem('Inspeções Veiculares', '/v2/inspecoes-veiculares', canSee),
    mkItem('Relatório de Custos', '/v2/relatorio-veiculo', canViewRelatorio && canSee),
  ];
};

export const gestaoVeicularSectionShow = ({ authData, userRole, variant = 'v1' }) => {
  if (variant === 'v1') {
    return !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(userRole);
  }
  return !isUsuarioUsoMuto(authData.email);
};
